var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 8,
    viewBox: "0 0 4 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69443 0.172852C2.51025 0.172852 2.33361 0.241138 2.20338 0.36269C2.07315 0.484241 1.99998 0.6491 1.99998 0.821C1.99998 0.992899 2.07315 1.15776 2.20338 1.27931C2.33361 1.40086 2.51025 1.46915 2.69443 1.46915C2.8786 1.46915 3.05524 1.40086 3.18547 1.27931C3.31571 1.15776 3.38887 0.992899 3.38887 0.821C3.38887 0.6491 3.31571 0.484241 3.18547 0.36269C3.05524 0.241138 2.8786 0.172852 2.69443 0.172852ZM2.52776 2.23396C1.97683 2.27717 0.472204 3.39631 0.472204 3.39631C0.379611 3.46112 0.407389 3.4568 0.481463 3.57779C0.555537 3.69446 0.546278 3.7031 0.634241 3.64693C0.726834 3.59075 0.879611 3.50001 1.13424 3.3531C2.11572 2.76544 1.29165 4.12223 0.870352 6.40804C0.703686 7.54014 1.79628 6.9568 2.07869 6.78396C2.35646 6.61544 3.10183 6.13581 3.17591 6.08828C3.27776 6.02347 3.20369 5.97162 3.12498 5.86359C3.06943 5.79014 3.01387 5.84199 3.01387 5.84199C2.71294 6.02779 2.16202 6.41668 2.08794 6.17038C1.99998 5.92409 2.5648 4.23458 2.87498 3.07223C2.92591 2.79569 3.0648 2.19075 2.52776 2.23396Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/i-icon.f861d37f.svg";
export { ForwardRef as ReactComponent };